<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-user-edit" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      form(@submit.prevent="onSubmit")
        .columns
          .column.col-6.col-lg-7.col-md-8.col-sm-12
            form-group(label="Nome" :validation="$v.author" field="name")
              input.form-input(v-model.trim="$v.author.name.$model")
            .divider.text-center(data-content="Resumos do autor")
            resumes(v-model="author.resumes")
            .divider
            form-group(label="Avatar" :validation="$v.author" field="photoURL")
              file-upload(
                v-model="$v.author.photoURL.$model"
                :input-attrs="{ accept: 'image/*' }"
                @upload-start="uploading = true"
                @upload-end="uploading = false"
              )
            .divider
            .text-right
              button.btn.btn-primary(:disabled="$v.$invalid") Salvar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Resumes from './components/Resumes'
import authors from '@/services/authors'

export default {
  data() {
    return {
      uploading: false,
      loading: false,
      error: null,
      author: {
        name: '',
        resumes: [],
        photoURL: '',
      },
    }
  },
  validations: {
    author: {
      name: { required },
      photoURL: {},
    },
  },
  components: { Resumes },
  computed: {
    disabled() {
      return this.uploading || this.loading || this.$v.$invalid
    },
    title() {
      return this.$route.params.id ? 'Editar autor' : 'Novo autor'
    },
    subtitle() {
      return 'Autores dos produtos'
    },
  },
  methods: {
    async onSubmit() {
      const { author } = this
      const submitFunction = author.id ? authors.update : authors.create
      try {
        this.loading = true
        await submitFunction(this.author)
        this.$toaster.success('O autor foi salvo')
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      const { data } = await authors.show(this.$route.params.id)
      this.author = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
